import { render, staticRenderFns } from "./PolizzaPage.vue?vue&type=template&id=0da9557e"
import script from "./PolizzaPage.vue?vue&type=script&lang=js"
export * from "./PolizzaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports